import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { debounce } from "lodash";
import dayjs from "dayjs";
import { ReactComponent as ColumnList } from "../../image/ColumnList.svg";
import { Trans, useTranslation } from "react-i18next";
import {
  Space,
  Select,
  DatePicker,
  Table,
  Input,
  Modal,
  Col,
  Form,
  Row,
  Popconfirm,
  Tooltip,
  Checkbox,
  Menu,
  Button,
  Dropdown,
  Popover,
  Breadcrumb,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import RefreshIcon from "../../image/refreshIcon.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { getRequest, postRequest } from "../../axios";
import moment from "moment";
import OrderApprove from "../../image/OrderApprove.svg";
import PendingActions from "../../image/PendingActions.svg";
import OrderStage from "../../image/OrderStage.svg";
import RfqFloat from "../../image/RfqFloat.svg";
import TotalCount from "../../image/TotalCount.svg";
import NegotiationStage from "../../image/NegotiationStage.svg";
import OfferStage from "../../image/OfferStage.svg";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import ComparativeScaleNew from "../../image/ComparativeScaleNew.png";
import Comparativ from "../../image/comparativ.png";
import { authUserData } from "../../utils/Helper";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import {
  ClockCircleOutlined,
  EyeOutlined,
  FilterOutlined,
  InfoCircleOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import "jspdf-autotable";
import DotRFQStatus from "../PR/DotRFQStatus";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";

const RFQHistory = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [reload, setReload] = useState(false);
  const { Search } = Input;
  const [totalCount, settotalCount] = useState(0);
  const [rfqHistory, setRFQHistory] = useState([]);
  const [rfqStatus, setRfqStatus] = useState("");
  const [selectedRow, setSelectedRow] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const formRef = useRef();
  const [selectedCard, setSelectedCard] = useState(null);
  const [clickedFilterButton, setClickedFilterButton] = useState(false);
  const formReFloatPriceRef = useRef();
  const [categoryTree, setCategoryTree] = useState([]);
  const [categoryTreeFilter, setCategoryTreeFilter] = useState("");
  const { id } = useParams();
  const [categoryId, setCategoryId] = useState(null);
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const [loading, setLoading] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [vendors, setVenors] = useState([
    { key: "1", name: "John Brown" },
    { key: "2", name: "Jim Green" },
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [
    isWithOutRestrictionReFloatModalOpen,
    setIsWithOutRestrictionReFloatModalOpen,
  ] = useState(false);

  const isCompanyAdmin = authUserData()?.role?.some(
    (role) => role.name === "Company Admin"
  );
  const hasCompanyRole = authUserData()?.company_role === "Company Admin";

  const [checkedList, setCheckedList] = useState([
    "category_tree_name",
    "operation",
    "rfq_number",
    "rfq_approval_date",
    "rfq_status",
    "rejected",
    "rfq_approver",
    "rfq_total_amount",
    // "material_details",
    // // "rfq_creator_name",
    // // "rfq_created_date"
    "material_details",
    "company",
    "purchase_requisition_material_type_name",
    "amount",
    "site_wise",
    "city_name",
    "site_name",
    "site_wise_total_amount",
  ]);

  const [filterDate, setFilterDate] = useState([
    "2D",
    "3D",
    "5D",
    "7D",
    "1M",
    "All",
  ]);
  const [selectedFilter, setSelectedFilter] = useState("5D");
  const getPastDate = (days) => {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return date;
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const shortYear = year % 100;
    return `${day}-${month}-${shortYear}`;
  };
  const dayMapping = {
    "2D": 1,
    "3D": 2,
    "5D": 4,
    "7D": 6,
    "1M": 29,
    All: 730,
  };
  const startDateFilter = formatDate(getPastDate(dayMapping["5D"]));
  const endDateFilter = formatDate(new Date());

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    rfq_created_date__gte: startDateFilter,
    rfq_created_date__lte: endDateFilter,
  });
  const [statusCounts, setStatusCounts] = useState({
    total_rfq: 0,
    approval_stage_count: 0,
    draft_pr_count: 0,
    negotiation_stage_count: 0,
    offer_stage_count: 0,
    order_placed_count: 0,
    rfq_cancelled_count: 0,
    rfq_floated_count: 0,
    rfq_hold_count: 0,
    rfq_under_approval_count: 0,
  });
  const [selectedPrNumber, setSelectedPrNumber] = useState(null);
  const [dotLoaded, setDotLoaded] = useState(false);

  const getRFQHistory = async () => {
    try {
      setLoading(true);

      const dependentFields = {
        rfq_approver: ["rfq_approver_email", "rfq_approver_phone"],
        rfq_creator_name: ["rfq_creator_email", "rfq_creator_phone"],
      };

      const fields = [
        ...new Set([
          "id",
          // "rfq_total_amount",
          "rfq_approval_status",
          // "rfq_approval_by",
          "rfq_reject_reason",
          "material_details",
          "purchase_order_approved",
          "purchase_order",
          // "rfq_details",
          ...checkedList.filter((key) => key !== "operation"),
          ...checkedList.flatMap((key) => dependentFields[key] || []),
        ]),
      ].join(",");
      let apiResponse = await getRequest(
        `float-rfq/list-rfq/?company_id=${CompanyId}&fields=${fields}`,
        // `float-rfq/list-rfq/?company_id=${CompanyId}`,

        state
      );

      if (apiResponse.data.results.data) {
        setRFQHistory(apiResponse.data.results.data);
        settotalCount(apiResponse.data.count);
      } else {
        ErrorNotificationMsg(t("error_in_rfq_history"));
      }
      setLoading(false);
    } catch (error) {
      ErrorNotificationMsg(t("error_in_rfq_history"));
      setLoading(false);
    }
  };

  useEffect(() => {
    const getStatusCount = async () => {
      try {
        let apiResponse = await getRequest(
          `float-rfq/company-rfq-status-count/?company_id=${CompanyID}`,
          state
        );
        if (apiResponse.data.success) {
          const message = apiResponse.data.data;
          setStatusCounts({
            total_rfq: message.total_rfq,
            approval_stage_count: message.comparison_approval_stage_count,
            draft_pr_count: message.draft_pr_count,
            negotiation_stage_count: message.negotiation_stage_count,
            offer_stage_count: message.offer_stage_count,
            order_placed_count: message.order_placed_count,
            rfq_cancelled_count: message.rfq_cancelled_count,
            rfq_floated_count: message.rfq_floated_count,
            rfq_hold_count: message.rfq_hold_count,
            rfq_under_approval_count: message.rfq_under_approval_count,
          });
        } else {
          ErrorNotificationMsg(t("error_in_requested_demo_list_status_count"));
        }
      } catch (error) {
        ErrorNotificationMsg(t("error_in_requested_demo_list_status_count"));
      }
    };

    const fetchData = async () => {
      try {
        const promises = [];
        promises.push(getRFQHistory());
        promises.push(getStatusCount());
        promises.push(getCategoryTree());

        await Promise.all(promises);
      } catch (error) {
        console.error("Error in fetchData:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  }, [reload, state, t, checkedList]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };
  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const applyFilter = (item) => {
    if (dayMapping[item] !== undefined) {
      const startDate = formatDate(getPastDate(dayMapping[item]));
      const endDate = formatDate(new Date());

      const filterParams = {
        rfq_created_date__gte: startDate,
        rfq_created_date__lte: endDate,
      };

      setState(filterParams);
    }
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "category_tree_name" && sortOrder === "ascend") {
      sortingEnumKey = "category_tree_name";
    }
    if (sortField === "category_tree_name" && sortOrder === "descend") {
      sortingEnumKey = "-category_tree_name";
    }
    if (sortField === "pr_creator" && sortOrder === "ascend") {
      sortingEnumKey = "pr_creator";
    }
    if (sortField === "pr_creator" && sortOrder === "descend") {
      sortingEnumKey = "-pr_creator";
    }
    if (sortField === "rfq_number" && sortOrder === "ascend") {
      sortingEnumKey = "rfq_number";
    }
    if (sortField === "rfq_number" && sortOrder === "descend") {
      sortingEnumKey = "-rfq_number";
    }
    if (sortField === "pr_approval_date" && sortOrder === "ascend") {
      sortingEnumKey = "pr_approval_date";
    }
    if (sortField === "pr_approval_date" && sortOrder === "descend") {
      sortingEnumKey = "-pr_approval_date";
    }
    if (sortField === "total_amount" && sortOrder === "ascend") {
      sortingEnumKey = "total_amount";
    }
    if (sortField === "total_amount" && sortOrder === "descend") {
      sortingEnumKey = "-total_amount";
    }
    if (sortField === "rfqstatus" && sortOrder === "ascend") {
      sortingEnumKey = "rfqstatus";
    }
    if (sortField === "rfqstatus" && sortOrder === "descend") {
      sortingEnumKey = "-rfqstatus";
    }

    return sortingEnumKey;
  };
  const handleStartDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YY");
    setStartDate(formattedDate);
  };

  const handleEndDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YY");
    setEndDate(formattedDate);
  };
  //
  const handleCategoryChange = (value) => {
    setCategoryTreeFilter(value);
  };

  const getCategoryTree = async () => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.set("no_pagination", "True");
      queryParams.set("fields", "id,name");

      const response = await getRequest(
        `category-tree/?${queryParams.toString()}`
      );
      if (response?.data?.data) {
        setCategoryTree(response.data.data);
      } else {
        ErrorNotificationMsg(t("error_in_category_tree"));
        setCategoryTree([]);
      }
    } catch (error) {
      console.error(
        "Error fetching category tree:",
        error.response?.data || error.message
      );
      ErrorNotificationMsg(
        t("error_in_category_tree") + ": " + (error.message || "Unknown error")
      );
      setCategoryTree([]);
    }
  };
  const handleReset = () => {
    setSelectedCard(null);
    setClickedFilterButton(false);
    setSelectedFilter("All");
    setRfqStatus("");
    setEndDate("");
    setStartDate("");
    setCategoryTreeFilter("");

    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
    });
    formRef.current.setFieldsValue({
      po_created_date__gte: null,
      pr_created_date__lte: null,
      pr_created_date__gte: null,
      rfq_created_date__gte: null,
      rfq_detail: null,
      category_id: null,
      rfq_created_date__lte: null,
    });
  };
  const handleClearFields = () => {
    setEndDate("");
    setStartDate("");
  };

  const handleRejectedChange = (value, index) => {
    setIsWithOutRestrictionReFloatModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setIsWithOutRestrictionReFloatModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setIsWithOutRestrictionReFloatModalOpen(false);
  };
  const handleReFloatPriceSubmit = async (values) => {
    // console.log(values);
  };
  const disabledDate = (current) => {
    return current && current < dayjs().startOf("day");
  };
  const handleDatepickerChange = (date, dateString, fieldName) => {
    const formattedDateString = dateString
      ? moment(dateString, "DD MMMM YYYY HH:mm").format("DD-MM-YYYY HH:mm")
      : null;
  };

  const handleRefresh = async () => {
    setSelectedFilter("All");
    setClickedFilterButton(false);
    setEndDate("");
    setStartDate("");
    setSelectedCard(null);
    formRef.current.setFieldsValue({
      po_created_date__gte: null,
      pr_created_date__lte: null,
      pr_created_date__gte: null,
      rfq_created_date__gte: null,
      rfq_detail: null,
      category_id: null,
      rfq_created_date__lte: null,
    });
    form.setFieldsValue({ search: "" });
    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
    });
  };
  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("float-rfq-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("rfq_history_archive_successfully"));
        setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_rfq_history_archive"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const handleScrap = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("float-rfq-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("rfq_history_archive_successfully1"));
        setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_rfq_history_archive1"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const handleApplyFilter = () => {
    setSelectedCard(null);
    setClickedFilterButton(true);
    const filterParams = {
      rfq_created_date__gte: startDate,
      rfq_created_date__lte: endDate,
      category_id: categoryTreeFilter,
      rfq_detail: rfqStatus,
    };

    setState(filterParams);
  };

  const handleEdit = (rfqId) => {
    setCategoryId(rfqId);
  };

  const handleHover = (prNumber) => {
    if (selectedPrNumber !== prNumber) {
      setSelectedPrNumber(prNumber);
    }
    setDotLoaded(false);
  };

  const columns = [
    {
      title: "Category",
      dataIndex: "category_tree_name",
      key: "category_tree_name",
      sorter: true,
    },
    {
      title: "RFQ Number",
      dataIndex: "rfq_number",
      key: "rfq_number",
      sorter: true,
    },
    {
      title: "RFQ Release Date",
      dataIndex: "rfq_approval_date",
      key: "rfq_approval_date",
      sorter: true,
      render: (rfq_approval_date, record) => {
        if (rfq_approval_date) {
          const dateParts = rfq_approval_date.split(" ");
          return dateParts[0];
        } else if (record.rfq_approval_status === "Reject With Reason") {
          return "Rejected";
        } else {
          return "Pending";
        }
      },
    },
    {
      title: "RFQ Approver",
      dataIndex: "rfq_approver",
      key: "rfq_approver",
      sorter: true,
      render: (rfq_approver, record) => {
        const rfq_approval_by = record.rfq_approval_by;
        const rfq_approval_date = record.rfq_approval_date;
        const email = record.rfq_approver_email || "N/A";
        const phone = record.rfq_approver_phone || "N/A";

        if (rfq_approval_date && rfq_approval_by) {
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span>{rfq_approver}</span>
              <Tooltip
                color="#094E8F"
                placement="bottom"
                title={
                  <>
                    <div>
                      <strong>Email:</strong> {email}
                    </div>
                    <div>
                      <strong>Phone:</strong> {phone}
                    </div>
                  </>
                }
              >
                <InfoCircleOutlined
                  style={{
                    color: "#094E8F",
                    marginLeft: "3px",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            </div>
          );
        } else if (rfq_approval_date && rfq_approval_by === null) {
          return "RFQ released directly";
        } else if (rfq_approval_by !== null) {
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span>{rfq_approver}</span>
              <Tooltip
                color="#094E8F"
                placement="bottom"
                title={
                  <>
                    <div>
                      <strong>Email:</strong> {email}
                    </div>
                    <div>
                      <strong>Phone:</strong> {phone}
                    </div>
                  </>
                }
              >
                <InfoCircleOutlined
                  style={{
                    color: "#094E8F",
                    marginLeft: "3px",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            </div>
          );
        } else {
          return "Pending";
        }
      },
    },
    {
      title: "RFQ Status",
      dataIndex: "rfq_status",
      key: "rfq_status",
      sorter: true,
    },
    {
      title: "Creator Name",
      dataIndex: "rfq_creator_name",
      key: "rfq_creator_name",
      sorter: true,
    },
    {
      title: "Created Date",
      dataIndex: "rfq_created_date",
      key: "rfq_created_date",
      sorter: true,
    },
    {
      title: "Est. Amount",
      dataIndex: "rfq_total_amount",
      key: "rfq_total_amount",
      sorter: true,
      align: "right",
      render: (text) => {
        const formattedAmount = text
          ? `₹ ${text.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`
          : "₹ 0";
        return <span>{formattedAmount}</span>;
      },
    },
    {
      title: "Rejected",
      dataIndex: "rfq_reject_reason",
      key: "rejected",
      sorter: true,
      width: "140px",
      render: (text, record) => {
        if (record.rfq_approval_status !== "Reject With Reason") {
          return null;
        }
        const reason = text || t("no_reason_provided");
        const maxLength = 10;
        const isTruncated = reason.length > maxLength;
        const displayText = isTruncated
          ? `${reason.slice(0, maxLength)}...`
          : reason;

        return (
          <Tooltip color="#094E8F" placement="bottom" title={<>{reason}</>}>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span>{displayText}</span>
              {isTruncated && (
                <InfoCircleOutlined
                  style={{
                    color: "#094E8F",
                    cursor: "pointer",
                  }}
                />
              )}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 120,
      render: (record) => {
        return (
          <Space>
            <Popover
              placement="left"
              content={
                <DotRFQStatus
                  prNumber={selectedPrNumber}
                  CompanyID={CompanyID}
                  prID={record.id}
                  setDotLoaded={setDotLoaded}
                />
              }
              title={`Status Of RFQ Number: ${record.rfq_number}
              `}
            >
              <ClockCircleOutlined
                onMouseEnter={() => handleHover(record.rfq_number)}
                style={{ cursor: "pointer" }}
              />
            </Popover>
            <Tooltip title="View RFQ">
              <Link to={`/request-for-quotation-view/${record.id}`}>
                <EyeOutlined />
              </Link>
            </Tooltip>
            {record.rfq_status === "RFQ under Approval" &&
            authUserData()?.permission?.includes("rfq|add_floatrfq") &&
            isCompanyAdmin !== hasCompanyRole ? (
              <Link to={`/request-for-quotation/add-rfq/${record?.id}`}>
                <Editicon onClick={() => handleEdit(record.id)} />
              </Link>
            ) : null}
            {authUserData()?.group_permission?.includes("rfq|add_floatrfq") &&
              authUserData()?.permission?.includes("rfq|delete_rfq") &&
              isCompanyAdmin !== hasCompanyRole &&
              (record.rfq_status === "RFQ under Approval" ? (
                <Popconfirm
                  className="action"
                  title={t("pop_title11")}
                  cancelText={t("pop_cancel")}
                  okText={t("pop_ok")}
                  onConfirm={() => handleScrap(record.id)}
                  placement="left"
                >
                  <Tooltip title="Scrap RFQ">
                    <Archive style={{ cursor: "pointer" }} />
                  </Tooltip>
                </Popconfirm>
              ) : (
                <Popconfirm
                  className="action"
                  title={t("pop_title")}
                  cancelText={t("pop_cancel")}
                  okText={t("pop_ok")}
                  onConfirm={() => handleArchive(record.id)}
                  placement="left"
                >
                  <Tooltip title="Archive" placement="left">
                    <Archive style={{ cursor: "pointer" }} />
                  </Tooltip>
                </Popconfirm>
              ))}

            {(record.rfq_status === "Offer Stage" ||
              record.rfq_status === "Negotiation Stage" ||
              record.rfq_status === "Comparison Approval Stage") &&
              record.purchase_order === false &&
              authUserData()?.group_permission?.includes(
                "rfq|add_floatrfq"
              ) && (
                <Tooltip title="Comparatives" placement="left">
                  {record.category_tree_name === "Cement" ||
                  record.category_tree_name.includes("Sand") || record.category_tree_name.includes("Aggregate") ? (
                    <Link
                      to={`/request-for-quotation/comparatives-by-city/${record.id}`}
                    >
                      <span>|</span>
                      <img
                        style={{ width: "100%" }}
                        src={ComparativeScaleNew}
                        alt=""
                      />
                    </Link>
                  ) : (
                    <Link
                      to={`/request-for-quotation/comparatives-by-city-by-diameter/${record.id}`}
                    >
                      <span>|</span>
                      <img
                        style={{ width: "100%" }}
                        src={ComparativeScaleNew}
                        alt=""
                      />
                    </Link>
                  )}
                </Tooltip>
              )}

            {authUserData()?.group_permission?.includes("rfq|add_floatrfq") &&
              record.purchase_order_approved === true && (
                <Tooltip title="View Comparatives" placement="left">
                  {record.category_tree_name === "Cement" ? (
                    <Link
                      to={`/request-for-quotation/comparatives-by-city/${record.id}`}
                    >
                      <span>|</span>
                      <img style={{ width: "100%" }} src={Comparativ} alt="" />
                    </Link>
                  ) : (
                    <Link
                      to={`/request-for-quotation/comparatives-by-city-by-diameter/${record.id}`}
                    >
                      <span>|</span>
                      <img style={{ width: "100%" }} src={Comparativ} alt="" />
                    </Link>
                  )}
                </Tooltip>
              )}
          </Space>
        );
      },
    },
  ];

  const vendorsColumns = [
    {
      title: "Vendor Name",
      dataIndex: "name",
      render: (text) => <>{text}</>,
    },
  ];
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setSelectedFilter("All");

    if (value) {
      setState((prevState) => {
        const {
          rfq_created_date__gte,
          rfq_created_date__lte,
          rfq_status,
          ...rest
        } = prevState;

        return {
          ...rest,
          search: value,
        };
      });
    } else {
      setState((prevState) => {
        const {
          rfq_created_date__gte,
          rfq_created_date__lte,
          search,
          ...rest
        } = prevState;

        return {
          ...rest,
        };
      });
    }
  };
  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const handleClickCard = (status) => {
    setSelectedCard(status);
    setRfqStatus("");
    setCategoryTreeFilter("");

    setState((prevState) => ({
      ...prevState,
      rfq_status: status || "",
      search: "",
      page: 1,
      pagesize: 10,
    }));
  };

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList([
      "operation",
      ...checkedValues.filter((v) => v !== "operation"),
    ]);
  };

  const filteredColumns = columns.filter((column) =>
    checkedList?.includes(column.key)
  );

  const columnMenu = (
    <Menu
      className="packagelistdropdown"
      style={{ width: "450px", padding: "10px", borderRadius: "8px" }}
    >
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Row style={{ width: "100%" }}>
            <Col span={12}>
              <Checkbox value="category_tree_name">Category</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="rfq_number" disabled>
                RFQ Number
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="rfq_approval_date">RFQ Release Date</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="rfq_approver">RFQ Approver</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="rfq_status">RFQ Status</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="rfq_creator_name">Creator Name</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="rfq_created_date">Created Date</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="rfq_total_amount" disabled>
                Est. Amount
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="rejected">Rejected</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="operation" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("rfq_history")} </h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">Dashboard</Link>
              </Breadcrumb.Item>

              <Breadcrumb.Item>{t("rfq_history")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp" style={{ height: "auto" }}>
              <Form form={form}>
                <Form.Item
                  name="search"
                  initialValue=""
                  style={{ margin: "0" }}
                >
                  <Search
                    prefix={
                      <img
                        src={SearchIcon}
                        alt="SearchIcon"
                        className="SearchIcon"
                        width={22}
                      />
                    }
                    placeholder={t("pl_search_list")}
                    onChange={searchCallbackDelayed}
                    style={{
                      width: 250,
                    }}
                  />
                </Form.Item>
              </Form>
            </div>
            {authUserData()?.permission?.includes("rfq|delete_rfq") &&
              isCompanyAdmin !== hasCompanyRole && (
                <Tooltip placement="topLeft" title="Archived Records">
                  <Link
                    to={`/request-for-quotation/history/archive`}
                    className="Archiveicon"
                  >
                    <Archiveicon />
                  </Link>
                </Tooltip>
              )}
          </Space>
        </div>
      </div>
      <section className="grid-sec mt-5 tablegridsec">
        <div className="PR-body">
          <SubscriptionNotification />
          <section className="Block-Sec-Demo1 mb-5">
            <Row gutter={[15]} className="rfqCard">
              {[
                {
                  status: "",
                  title: "Total RFQ",
                  count: statusCounts.total_rfq,
                  icon: TotalCount,
                },
                {
                  status: "RFQ under Approval",
                  title: "RFQ under Approval",
                  count: statusCounts.rfq_under_approval_count,
                  icon: PendingActions,
                },
                {
                  status: "RFQ Floated",
                  title: "RFQ Floated",
                  count: statusCounts.rfq_floated_count,
                  icon: RfqFloat,
                },
                {
                  status: "Offer Stage",
                  title: "Offer Stage",
                  count: statusCounts.offer_stage_count,
                  icon: OfferStage,
                },
                {
                  status: "Negotiation Stage",
                  title: "Negotiation Stage",
                  count: statusCounts.negotiation_stage_count,
                  icon: NegotiationStage,
                },
                {
                  status: "Comparison Approval Stage",
                  title: "Comparison Approval Stage",
                  count: statusCounts.approval_stage_count,
                  icon: OrderApprove,
                },
                {
                  status: "Order Placed",
                  title: "Ordering Stage",
                  count: statusCounts.order_placed_count,
                  icon: OrderStage,
                },
              ].map((item, index) => (
                <Col key={index}>
                  <div
                    className={`card mb-5 ${
                      selectedCard === item.status ? "active" : ""
                    }`}
                    onClick={() => handleClickCard(item.status)}
                    style={{
                      width: "fit-content",
                    }}
                  >
                    <div className="card-block">
                      <div className="card-box">
                        <div className="card-icon">
                          <img src={item.icon} alt={item.title} width={35} />
                        </div>
                        <div className="card-description">
                          <h3 className="color-blue">{item.title}</h3>
                          <p>{item.count}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </section>
          <div className="filterrow">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef}>
                <Space wrap>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="rfq_created_date__gte">
                      <DatePicker
                        format="DD-MM-YY"
                        allowClear={false}
                        placeholder="Select Start Date"
                        value={startDate}
                        onChange={handleStartDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="rfq_created_date__lte">
                      <DatePicker
                        format="DD-MM-YY"
                        allowClear={false}
                        placeholder="Select End Date"
                        value={endDate}
                        onChange={handleEndDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="category_id">
                      <Select
                        // showSearch
                        allowClear
                        placeholder={
                          t("pl_select_category") || "Select Category"
                        }
                        value={categoryTreeFilter}
                        onChange={handleCategoryChange}
                        style={{ minWidth: 180 }}
                        optionFilterProp="children"
                      >
                        {categoryTree.map((cat) => (
                          <Select.Option key={cat.id} value={cat.id}>
                            {cat.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <>
                    <Button
                      type="primary"
                      htmlType="Apply"
                      icon={
                        <Tooltip title="Apply" color="#094E8F">
                          <FilterOutlined style={{ fontSize: "20px" }} />
                        </Tooltip>
                      }
                      style={{
                        backgroundColor: "#094e8f",
                        color: "#ffffff",
                        border: "none",
                        width: "40px",
                        height: "40px",
                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                        borderRadius: "4px",
                      }}
                      onClick={
                        startDate || endDate || categoryTreeFilter
                          ? handleApplyFilter
                          : null
                      }
                    />

                    <Button
                      htmlType="Reset"
                      type="primary"
                      icon={
                        <Tooltip title="Reset" color="#094E8F">
                          <UndoOutlined style={{ fontSize: "20px" }} />
                        </Tooltip>
                      }
                      onClick={
                        clickedFilterButton ? handleReset : handleClearFields
                      }
                      style={{
                        backgroundColor: "#094e8f",
                        color: "#ffffff",
                        border: "none",
                        width: "40px",
                        height: "40px",
                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                        borderRadius: "4px",
                      }}
                    />
                  </>
                </Space>
              </Form>
            </div>

            <div className="btnscol">
              <Space>
                <Col xs={24}>
                  <h5
                    className="rfq-number"
                    style={{ color: "#094E8F", display: "flex", margin: "0" }}
                  >
                    <Tooltip
                      color="#094E8F"
                      title={"RFQ filter by number of days / month"}
                    >
                      Last:
                    </Tooltip>
                    <span className="rfq-number new">
                      {filterDate.map((item, index) => (
                        <span
                          key={index}
                          style={{
                            backgroundColor: selectedFilter === item && "white",
                            margin: "0 5px",
                            padding: "8px 18px",
                            cursor: "pointer",
                            fontWeight:
                              selectedFilter === item ? "bold" : "normal",
                            color: selectedFilter === item ? "black" : "black",
                            border:
                              selectedFilter === item
                                ? "0.5px solid rgb(154, 165, 177)"
                                : "none",
                            boxShadow:
                              selectedFilter === item
                                ? "-1px 1px 5px 2px rgba(56,135,201,0.75)"
                                : "none",
                            transition: "box-shadow 0.3s ease-in-out",
                          }}
                          onClick={() => {
                            setSelectedFilter(item);
                            applyFilter(item);
                            setSelectedCard(null);
                          }}
                        >
                          {item}
                        </span>
                      ))}
                    </span>
                  </h5>
                </Col>
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Refresh"
                  label="Refresh"
                  onClick={handleRefresh}
                  icon={<img src={RefreshIcon} alt="Refresh Icon" />}
                />
                <div>
                  <Space
                    style={{
                      backgroundColor: "#094e8f",
                      padding: "4px",
                      borderRadius: "4px",
                    }}
                  >
                    <Dropdown
                      overlay={columnMenu}
                      trigger={["hover"]}
                      placement="bottomRight"
                      visible={dropdownVisible}
                      onVisibleChange={setDropdownVisible}
                    >
                      <Tooltip
                        title="Modify Columns"
                        placement="topLeft"
                        color="#094E8F"
                      >
                        <Button
                          className="SaveGradiantBtn"
                          type="primary"
                          icon={<ColumnList />}
                          style={{ minWidth: "36px" }}
                        />
                      </Tooltip>
                    </Dropdown>
                  </Space>
                </div>
              </Space>
              {selectedRow.length > 0 &&
                authUserData()?.group_permission?.includes(
                  "rfq|add_floatrfq"
                ) && (
                  <Popconfirm
                    className="action"
                    title={t("pop_title")}
                    okText={t("pop_ok")}
                    cancelText={t("pop_cancel")}
                    placement="left"
                    onConfirm={() => handleArchive()}
                  >
                    <ButtonField
                      className="BlueShadowBtn"
                      type="primary"
                      htmlType="button"
                      label={t("pl_Archive")}
                    />
                  </Popconfirm>
                )}
            </div>
          </div>
          <div className="tablewrp">
            <Table
              columns={filteredColumns}
              rowSelection={rowSelection}
              dataSource={rfqHistory}
              rowKey={(record) => record.id}
              loading={loading}
              pagination={{
                current: state.page,
                pageSize: state.pagesize,
                defaultCurrent: state.page,
                defaultPageSize: state.pagesize,
                total: totalCount,
                showSizeChanger: true,
                locale: {
                  items_per_page: "Items / Page",
                },
                showTotal: (total) => `Total ${total} items`,
              }}
              scroll={{
                x: "auto",
              }}
              onChange={handleTableChange}
            />
          </div>
        </div>

        <Modal
          className="ModelPopupSecDemo"
          title={
            <>
              {t("rfq_float_for_price_submission")}
              <div
                className="modal-subtitle"
                style={{ fontSize: "15px", color: "gray" }}
              >
                System with restriction
              </div>
            </>
          }
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[]}
          closable={false}
          keyboard={false}
          maskClosable={false}
          wrapClassName="modal-wrapper"
        >
          <Form
            autoComplete="off"
            ref={formReFloatPriceRef}
            onFinish={handleReFloatPriceSubmit}
          >
            <Row gutter={[15]}>
              <Col md={12} className="TextFeild">
                <Form.Item
                  name="rfq_re_float_price_start_date"
                  rules={[
                    {
                      required: true,
                      message: <Trans>Please Select Start Date Time</Trans>,
                    },
                  ]}
                >
                  <DatePicker
                    showTime={true}
                    showNow={false}
                    placeholder="From date time"
                    format="DD MMMM YYYY  HH:mm"
                    disabledDate={disabledDate}
                    onChange={(date, dateString) =>
                      handleDatepickerChange(date, dateString, "demo_date")
                    }
                    value=""
                  />
                </Form.Item>
              </Col>
              <Col md={12} className="TextFeild">
                <Form.Item
                  name="rfq_re_float_price_end_date"
                  rules={[
                    {
                      required: true,
                      message: <Trans>Please Select End Date Time</Trans>,
                    },
                  ]}
                >
                  <DatePicker
                    showTime={true}
                    showNow={false}
                    placeholder="End date time"
                    format="DD MMMM YYYY  HH:mm"
                    disabledDate={disabledDate}
                    onChange={(date, dateString) =>
                      handleDatepickerChange(date, dateString, "demo_date")
                    }
                    value=""
                  />
                </Form.Item>
              </Col>
              <div className="ModalPopupFooter">
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Submit"
                  label={t("submit")}
                />
              </div>
            </Row>
          </Form>
        </Modal>

        <Modal
          className="ModelPopupSecDemo"
          title={
            <>
              {t("rfq_float_for_price_submission")}
              <div
                className="modal-subtitle"
                style={{ fontSize: "15px", color: "gray" }}
              >
                System without restriction
              </div>
            </>
          }
          open={isWithOutRestrictionReFloatModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[]}
          closable={false}
          keyboard={false}
          maskClosable={false}
          wrapClassName="modal-wrapper"
        >
          <Form
            autoComplete="off"
            ref={formReFloatPriceRef}
            onFinish={handleReFloatPriceSubmit}
          >
            <Row gutter={[15]}>
              <Col md={12} className="TextFeild">
                <Form.Item
                  name="rfq_re_float_price_start_date"
                  rules={[
                    {
                      required: true,
                      message: <Trans>Please Select Start Date Time</Trans>,
                    },
                  ]}
                >
                  <DatePicker
                    showTime={true}
                    showNow={false}
                    placeholder="From date time"
                    format="DD MMMM YYYY  HH:mm"
                    disabledDate={disabledDate}
                    onChange={(date, dateString) =>
                      handleDatepickerChange(date, dateString, "demo_date")
                    }
                    value=""
                  />
                </Form.Item>
              </Col>
              <Col md={12} className="TextFeild">
                <Form.Item
                  name="rfq_re_float_price_end_date"
                  rules={[
                    {
                      required: true,
                      message: <Trans>Please Select End Date Time</Trans>,
                    },
                  ]}
                >
                  <DatePicker
                    showTime={true}
                    showNow={false}
                    placeholder="End date time"
                    format="DD MMMM YYYY  HH:mm"
                    disabledDate={disabledDate}
                    onChange={(date, dateString) =>
                      handleDatepickerChange(date, dateString, "demo_date")
                    }
                    value=""
                  />
                </Form.Item>
              </Col>
            </Row>

            <Table
              columns={vendorsColumns}
              rowSelection={rowSelection}
              dataSource={vendors}
              rowKey={(record) => record.id}
              pagination={false}
              onChange={handleTableChange}
              loading={loading}
            />

            <Row>
              <div className="ModalPopupFooter">
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Submit"
                  label={t("submit")}
                />
              </div>
            </Row>
          </Form>
        </Modal>
      </section>
    </>
  );
};
export default RFQHistory;
